/* @flow */
import emojiAnnotationMap from 'emoji-annotation-to-unicode';
import React from 'react';

import { imgSrcForEmojiHex } from 'lib/emoji';

import styles from './styles/ShortcodeEmoji.css';

function styleFor(title) {
  const hex = emojiAnnotationMap[title];

  const src = imgSrcForEmojiHex(hex);

  return {
    backgroundImage: `url(${src})`,
  };
}

/**
 * Displays an emoji character for a given
 * [annotation](http://unicode.org/emoji/charts/emoji-annotations.html). Note
 * that annotations are a many-to-many relationship, so we use the emoji-
 * annotation-to-unicode map generated from [Github's Emoji
 * API](https://developer.github.com/v3/emojis/).
 *
 * ```example
 *  <div>
 *    <ShortcodeEmoji text=":mortar_board:" />
 *  </div>
 * ```
 *
 * You will rarely use this component directly. Rather, look at `TextWithEntities` and
 * `TextEntities` to parse and convert Emoji for cross-platform support.
 *
 * ```js
 *  <TextWithEntities
 *    text={text}
 *    entities={
 *      [].concat(
 *        TextEntities.parseShortcodeEmoji(text),
 *      )
 *    }
 *  />
 * ```
 *
 */
// UNTIL prop-types lint can detect Flow annotation
/* eslint-disable react/prop-types */
function ShortcodeEmoji ({ text }: {text: string}) {
  // cut out the leading and trailing colons
  const title = text.slice(1, -1);

  try {
    return (
      <span
        className={styles.this}
        style={styleFor(title)}
        title={title}>
        {text}
      </span>
    );
  } catch (ex) {
    console.warn('No emoji for shortcode', text);
    return <span>{text}</span>;
  }
}

export default ShortcodeEmoji;



// WEBPACK FOOTER //
// ./src/components/ShortcodeEmoji.jsx